{
	"empty": "Pas de données à afficher",
	"table": "Table"
}
